import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Form } from 'semantic-ui-react';
import { resetSearch, setSearch } from '../../data/searchField/actions';
import SearchField from '../Shared/SearchField';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealerNumber: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { setSearchFields } = this.props;
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const variableArguments = {
      dealerNumber: value,
    };
    this.setState({ [name]: value, changed: { [name]: true } });
    setSearchFields(variableArguments);
  }

  render() {
    const {
      onSubmit,
      searchFields,
      searchOptions,
      multipleSearches,
    } = this.props;
    const { state } = this;

    return (
      <div>
        <Form onSubmit={onSubmit}>
          <Form.Group widths='two'>
            {map(searchOptions, searchOption => (
              <SearchField
                handleInputChange={this.handleInputChange}
                searchOption={searchOption}
                searchFields={searchFields}
                value={state[searchOption]}
                multipleSearches={multipleSearches}
                key={searchOption}
              />
            ))}
            <Form.Field>
              <Form.Button color='green' inverted data-testid='dealer-manager-search-btn'>
                Search
              </Form.Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

Search.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
  setSearchFields: PropTypes.func.isRequired,
  searchOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  multipleSearches: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  resetSearchFields: field => {
    dispatch(resetSearch(field));
  },
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  )
)(Search);
